import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import { Instagram, Mail, MapPin, Phone } from "lucide-react";

export default function Contact() {
  return (
    <div className="App">
      <Navbar />
      <div className="mx-auto max-w-6xl px-6 py-20 lg:px-10 lg:py-28" data-testid="contact-page">
        <p className="label-tiny mb-3">Get in touch</p>
        <h1 className="font-serif text-4xl leading-tight text-[#2a2928] sm:text-5xl lg:text-6xl">
          Let&apos;s craft something{" "}
          <span className="italic text-[#d08c8c]">memorable.</span>
        </h1>
        <p className="mt-4 max-w-lg text-[#7a7571]">
          For custom orders, bulk gifting, or any questions — we usually reply within a few hours.
        </p>

        <div className="mt-12 grid grid-cols-1 gap-6 sm:grid-cols-2">
          {[
            { icon: Mail, label: "Email", value: "balloonbiteshelps@gmail.com", link: "mailto:balloonbiteshelps@gmail.com" },
            { icon: Phone, label: "Phone / WhatsApp", value: "+91 78994 81956", link: "https://wa.me/917899481956" },
            { icon: Instagram, label: "Instagram", value: "@balloonbites", link: "https://www.instagram.com/balloonbites/" },
            { icon: MapPin, label: "Studio", value: "Hassan, Karnataka · by appointment", link: null },
          ].map((c) => (
            <a
              key={c.label}
              href={c.link || "#"}
              target={c.link?.startsWith("http") ? "_blank" : undefined}
              rel="noreferrer"
              className="flex items-start gap-4 rounded-3xl border border-[#e8e2da] bg-white p-6 hover:border-[#d08c8c]"
              data-testid={`contact-${c.label.toLowerCase().replace(/\W/g, "-")}`}
            >
              <div className="rounded-full bg-[#faf1ee] p-3">
                <c.icon className="h-5 w-5 text-[#d08c8c]" />
              </div>
              <div>
                <div className="text-xs uppercase tracking-[0.18em] text-[#7a7571]">{c.label}</div>
                <div className="mt-1 font-medium text-[#2a2928]">{c.value}</div>
              </div>
            </a>
          ))}
        </div>
      </div>
      <Footer />
    </div>
  );
}
